import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import Edit from '@material-ui/icons/Edit'
import TextField from "@material-ui/core/TextField";
import {Objects} from "../index";

export default class KpiMetrics extends Framework.Components.Collection {
	constructor(props) {

		let model = new API.BuildClass(Types.Kpi_Metrics._name, API.RequestType.READ_ALL);
		super(props,model);
		this.state.limit = 16;
		this.state.edit_modal = false;
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns=[
			{
				Header: "Role",
				id: 'name',
				/** @param {Kpi_Metrics_Object} obj */
				accessor: obj => obj.roles?.name,
			},
			{
				Header: "Hourly Limit (Daily for Hiring)",
				id: 'hourly',
				/** @param {Kpi_Metrics_Object} obj */
				accessor: obj => obj.hourly,
			},
			{
				Header: "Daily Limit (Weekly for Hiring)",
				id: 'daily',
				/** @param {Kpi_Metrics_Object} obj */
				accessor: obj => obj.daily,
			},
			{
				Header: "Optional Multiplier",
				id: 'multiplier',
				/** @param {Kpi_Metrics_Object} obj */
				accessor: obj => obj.multiplier,
			},
			{
				Header: "Edit",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 50,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
							this.setState({kpi: props.original.pkey});
							this.handleToggleModal('modalKpiEdit')
						}}>
							<Edit fontSize={'small'}/>
						</Button>
					);
				}
			},

		]
		const regexp = new RegExp(/\D/, 'g');
		return (
			<Card>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
				<Framework.Elements.UniversalModal
					name={"KPI Metric"}
					object={Objects.KpiMetric}
					toggle={this.state.modalKpiEdit}
					reportClose={this.reportClose('modalKpiEdit')}
					id={this.state.kpi}
					afterSave={() => {this.setState({key: Math.random()})}}
					title={"Update KPI Metric"}
					hideGoTo={true}
				/>
			</Card>
		)
	}
}
